import React, {useEffect, useState} from "react";
import {useAsyncFn} from "react-use";

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Skeleton
} from "@mui/material";
import {LoadingButton} from "@mui/lab";

import {apiClient} from "../../../../app/client/app/client";
import {ModelRevisionRef, ModelRevisionRefDto} from "../../../../app/client/app/entity/report/model/ReportModel";
import {PRRKey} from "../../../../app/client/app/entity/Project";


interface ComponentProps {
    prrKey: PRRKey
    currentRevisionId: string | undefined

    isOpen: boolean
    close: () => void
    apply: (analysisSettingsRef: ModelRevisionRef) => void
}

const SelectBaseAnalysisSettingsDialog = (props: ComponentProps) => {
    const [selectedItem, setSelectedItem] = useState<number | undefined>(undefined);
    const [refs, setRefs] = useState<ModelRevisionRefDto[] | undefined>(undefined);
    useEffect(() => {
        if (props.isOpen) {
            apiClient.listAnalysisSettingsRefs()
                .then(response => {
                    const revisionRefs = response.data;
                    if (response.errorReason === undefined && revisionRefs !== undefined) {
                        setRefs(revisionRefs)

                        if (props.currentRevisionId !== undefined) {
                            const index = revisionRefs.findIndex(ref => ref.revisionId === props.currentRevisionId);
                            if (index < 0) {
                                setSelectedItem(undefined);
                            } else {
                                setSelectedItem(index);
                            }
                        }
                    }
                });
        }
    }, [props.isOpen, props.currentRevisionId])

    const [attachModelState, attachModel] = useAsyncFn(async (prrKey: PRRKey, refDto: ModelRevisionRefDto) => {
        return await apiClient.attachAnalysisSettingsRef(prrKey, refDto.modelId, refDto.revisionId);
    }, []);

    const handleToggle = (value: number) => () => {
        if (value === selectedItem) {
            setSelectedItem(undefined)
        } else {
            setSelectedItem(value)
        }
    };

    return <Dialog open={props.isOpen} fullWidth maxWidth={"sm"}>
        <DialogTitle>
            Select Analysis Settings
        </DialogTitle>

        <DialogContent>
            { refs === undefined &&
                <div>
                    <Skeleton/>
                    <Skeleton/>
                    <Skeleton/>
                </div>
            }
            { refs !== undefined &&
                <List dense>
                    { refs.map((ref, index) => {
                        const labelId = `checkbox-list-label-${index}`;

                        return <ListItemButton
                            dense
                            onClick={handleToggle(index)}
                        >
                            <ListItemIcon>
                                <Checkbox
                                    edge="start"
                                    tabIndex={-1}
                                    disableRipple
                                    checked={selectedItem === index}
                                    inputProps={{ 'aria-labelledby': labelId }}
                                />
                            </ListItemIcon>
                            <ListItemText
                                id={labelId}
                                primary={`${ref.modelName} / ${ref.revisionDate}`}
                                secondary={ref.revisionId}
                            />
                        </ListItemButton>
                    })}
                </List>
            }
        </DialogContent>

        <DialogActions>
            <Button onClick={props.close}>Cancel</Button>
            <LoadingButton
                variant="contained"
                color="secondary"
                loading={attachModelState.loading}
                onClick={() => {
                    if (refs !== undefined && selectedItem !== undefined && selectedItem >= 0) {
                        const selectedRef = refs[selectedItem];
                        attachModel(props.prrKey, selectedRef)
                            .then(response => {
                                console.log(response)
                                if (response.errorReason === undefined) {
                                    if (response.data?.status === "ok" || response.data?.status === "not_change") {
                                        props.apply(selectedRef);
                                    }
                                }
                            });
                    }
                }}
            >
                Apply
            </LoadingButton>
        </DialogActions>
    </Dialog>
}

export {SelectBaseAnalysisSettingsDialog}
